var styles = {"priceSummary":"ep-pricing-module-price-summary-cHJpY"};

export { styles as default };
